import { coreMessages, type AppLocale } from './base-messages';

export const it: AppLocale = {
  ...coreMessages,
  dataTable: {
    rowModeLabel: 'Row display',
    rowModeEllipsis: 'Truncate (…)',
    rowModeScroll: 'Single line + horizontal scroll',
    rowModeWrap: 'Wrap lines',
    columnsLabel: 'Columns',
    reorderColumnHint: 'Drag the handle to move this column',
    resetThisTablePrefs: 'Reset this table',
    resetThisTablePrefsTitle: 'Clear saved layout for this table only (row mode, columns, order, widths). Does not change your global user settings.',
    dataOperationsLabel: 'Operazioni dati',
    operationExportExcel: 'Scarica Excel',
    operationDownloadTemplate: 'Scarica modello',
    operationUploadTemplate: 'Carica modello',
    operationImportHistory: 'Cronologia importazioni',
    operationFieldDictionary: 'Dizionario dei campi',
    operationUnsupported: 'Questa tabella non supporta questa operazione.',
    operationNoPermission: 'Non hai l\'autorizzazione per questa operazione.',
    operationNotReady: 'Questa operazione non è ancora pronta.',
    customFieldColumnsSectionLabel: 'Campi personalizzati',
    importModalTitle: 'Carica modello',
    importChooseFile: 'Scegli file CSV',
    importChooseFileHint: 'Compila e carica il modello scaricato da questa tabella.',
    importNoFile: 'Nessun file selezionato.',
    importSummary: 'Riepilogo importazione',
    importReadyRows: 'Righe pronte',
    importErrorRows: 'Righe con errori',
    importWarnings: 'Avvisi',
    importUnknownHeaders: 'Colonne sconosciute',
    importMissingRequiredHeaders: 'Colonne obbligatorie mancanti',
    importPreview: 'Anteprima',
    importSubmit: 'Avvia importazione',
    importCancel: 'Annulla',
    importParsing: 'Lettura file...',
    importSubmitting: 'Importazione in corso...',
    importNoValidRows: 'Non ci sono righe valide da importare.',
    importFailed: 'Importazione non riuscita.',
    importSucceeded: 'Importazione completata.',
    operationExportCsv: 'Scarica CSV',
    operationExportPdf: 'Scarica PDF',
    operationNoRows: 'Non ci sono righe visibili da esportare.',
    importUnknownHeader: 'Colonna sconosciuta: {header}',
    importMissingRequiredHeader: 'Colonna obbligatoria mancante: {header}',
    importRequiredCell: '{header} è obbligatorio.',
    importMaxRowsExceeded: 'Il file contiene più di {maxRows} righe; sono state valutate solo le prime {maxRows}.',
    refreshLabel: 'Aggiorna',
    focusModeEnterLabel: 'Metti a fuoco la tabella',
    focusModeFullscreenLabel: 'Apri a schermo intero',
    focusModeExitLabel: 'Esci dalla messa a fuoco',
    horizontalScrollLabel: 'Scorri le colonne della tabella',
    selectionModeLabel: 'Seleziona righe',
    selectAllRowsLabel: 'Seleziona tutte le righe',
    selectRowLabel: 'Seleziona riga',
    bulkSelectedLabel: '{count} selezionate',
    bulkActionsLabel: 'Azioni massive',
    tableSettingsLabel: 'Impostazioni tabella',
    appearanceSectionLabel: 'Aspetto',
    columnsSectionLabel: 'Colonne',
    rowActionsLabel: 'Azioni riga',
  },
  passwordReset: {
    title: 'Imposta una nuova password',
    description: 'Scegli una nuova password robusta, nota solo a te.',
    newPassword: 'Nuova password',
    confirmPassword: 'Conferma nuova password',
    passwordHelp: 'Usa almeno 12 caratteri e almeno tre tipi tra minuscole, maiuscole, numeri e caratteri speciali.',
    mismatch: 'Le password non corrispondono.',
    invalidLink: 'Il link di reimpostazione manca, non è valido o è scaduto.',
    submit: 'Aggiorna password',
    submitting: 'Aggiornamento password...',
    success: 'La password è stata aggiornata. Ora puoi accedere con la nuova password.',
    backToLogin: 'Torna all’accesso',
    requestTitle: 'Invia link di reimpostazione password',
    requestDescription: 'Un link monouso valido per 30 minuti verrà inviato all’indirizzo e-mail registrato dell’utente. La password attuale non cambia finché il link non viene utilizzato.',
    requestSend: 'Invia link',
    requestSending: 'Invio in corso...',
    requestSuccess: 'Il link di reimpostazione è stato accettato per l’invio.',
    requestError: 'Impossibile inviare il link di reimpostazione.',
    selfServiceOpen: 'Password dimenticata',
    selfServiceTitle: 'Password dimenticata',
    selfServiceDescription: 'Inserisci l’e-mail del tuo account aziendale. Se corrisponde a un account, verrà inviato un link monouso valido per 30 minuti.',
    selfServiceEmailLabel: 'E-mail',
    selfServiceSubmit: 'Richiedi link',
    selfServiceSubmitting: 'Invio richiesta...',
    selfServiceAcknowledgement: 'Se questa e-mail è registrata, verrà inviato un link di reimpostazione. Controlla la posta in arrivo e lo spam.',
    selfServiceClose: 'Chiudi',
    selfServiceCancel: 'Annulla',
    selfServiceError: 'Impossibile completare la richiesta. Riprova più tardi.',
    selfServiceRateLimited: 'Troppe richieste. Riprova più tardi.',
  },
  relationshipGraph: {
    sourceColumn: 'Origine',
    relationshipColumn: 'Relazione',
    targetColumn: 'Record collegato',
    showDetails: 'Mostra dettagli',
    hideDetails: 'Nascondi dettagli',
    controlsLabel: 'Controlli della mappa',
    title: 'Mappa delle relazioni',
    diagramLabel: 'Relazioni del record',
    diagramHelp: 'Seleziona una scheda per esaminare i collegamenti registrati.',
    detailsTitle: 'Dettagli del record',
    connectionsTitle: 'Collegamenti',
    noConnections: 'Nessun collegamento',
    loading: 'Caricamento delle relazioni…',
    forbidden: 'Non hai accesso a queste relazioni.',
    error: 'Impossibile caricare le relazioni. Chiudi e riprova.',
    empty: 'Questo record non ha collegamenti visualizzabili.',
    invalid: 'Impossibile verificare le relazioni. Chiudi e riprova.',
    close: 'Chiudi mappa delle relazioni',
    zoomIn: 'Ingrandisci',
    zoomOut: 'Riduci',
    fitView: 'Adatta mappa',
  },
  permissionPicker: {
    application: 'Applicazione',
    module: 'Modulo',
    action: 'Azione',
    permissions: 'Permessi',
    description: 'Descrizione',
    selection: 'Selezione',
    sharedPermissions: 'Permessi condivisi',
    selectedPermissions: '{count} permessi selezionati',
    selectedOnly: 'Solo selezionati',
    unselectedOnly: 'Solo non selezionati',
    selectedFirst: 'Selezionati per primi',
    noPermissions: 'Nessun permesso',
  },
  errors: {
    ...coreMessages.errors,
    unknown: 'Si è verificato un errore sconosciuto',
    network: 'Impossibile connettersi al server. Verificare la connessione Internet.',
    timeout: 'Timeout della richiesta. Riprovare.',
    badRequest: 'Richiesta non valida',
    unauthorized: 'Sessione scaduta. Effettuare nuovamente l\'accesso.',
    forbidden: 'Non hai il permesso per questa azione.',
    notFound: 'Risorsa richiesta non trovata',
    tooManyRequests: 'Troppe richieste inviate. Riprovare più tardi.',
    internalServerError: 'Errore del server. Riprovare più tardi.',
    badGateway: 'Server temporaneamente non disponibile',
    serviceUnavailable: 'Servizio temporaneamente non disponibile',
    gatewayTimeout: 'Il server non risponde',
    serverErrorWithStatus: 'Errore del server ({status})',
  },
  common: {
    databaseUnavailableDeveloperHint: 'Nota per sviluppatori: in sviluppo locale di solito significa che la VPN è disattivata o che l’IP non è autorizzato. Verifica VPN e accesso al database.',
    ...coreMessages.common,
    requestTimeout: 'The request timed out. Please try again.',
    backendConnectionErrorDev: 'Impossibile connettersi al server backend. Assicurarsi che il server sia in esecuzione ({apiUrl}).',
    backendConnectionErrorProd: 'Impossibile connettersi al server backend. Riprovare più tardi.',
    systemUpdating: 'Aggiornamento del sistema...',
    serverConfiguring: 'Configurazione del server in corso, attendere...',
    forbidden: 'Access denied.',
    network: 'Network error.',
    select: 'Seleziona',
    cancel: 'Annulla',
    save: 'Salva',
    saving: 'Salvataggio...',
    edit: 'Modifica',
    view: 'Visualizza',
    copy: 'Copia',
    delete: 'Elimina',
    appLauncher: 'Applicazioni',
    allApps: 'Tutte le applicazioni',
    loading: 'Caricamento...',
    noData: 'Nessun dato',
    code: 'Codice',
    profileMenu: 'Menu profilo',
    selectLanguage: 'Seleziona lingua',
    perPage: 'Per pagina',
    firstPage: 'Prima pagina',
    previousPage: 'Pagina precedente',
    nextPage: 'Pagina successiva',
    lastPage: 'Ultima pagina',
    pleaseWait: 'Attendere prego',
    migrationDescription: 'Aggiornamento del database in corso. L\'operazione potrebbe richiedere alcuni secondi.',
    changeText: 'Modifica',
    deleteLogo: 'Elimina logo',
    logoUploadHint: 'Dimensione max: 5 MB. Formati: JPEG, PNG, GIF, WebP',
    deleteAvatar: 'Elimina foto profilo',
    avatarUploadHint: 'Max 5 MB. JPEG, PNG, GIF, WebP.',
    newRecord: 'Nuovo record',
    noPermission: 'Non hai il permesso',
    searchPlaceholder: 'Cerca...',
    allStatuses: 'Tutti gli stati',
    active: 'Attivo',
    inactive: 'Inattivo',
    clearFilters: 'Cancella filtri',
    all: 'Tutti',
    clickToChangeStatus: 'Clicca per cambiare lo stato',
    noChangePermission: 'Non hai il permesso di cambiare lo stato',
    statusDistribution: 'Distribuzione stato',
    hide: 'Nascondi',
    show: 'Mostra',
    companies: 'Companies',
    adminConsole: 'Console di amministrazione',
    manageAccount: 'Gestisci il tuo account',
    manageYourAccount: 'Gestisci il tuo account',
    notificationsTitle: 'Notifiche',
    notificationsUnread: 'non lette',
    notificationsTypesMuted: 'tipi silenziati',
    notificationsViewAll: 'Mostra tutto',
    notificationsPreferences: 'Preferenze',
    notificationsMutedLabel: 'Silenziato',
    notificationsEmpty: 'Nessuna notifica',
    selectAll: 'Seleziona tutto',
    id: 'ID',
    remove: 'Rimuovi',
    syncDeletedResult: '{count} voci orfane rimosse.',
    distributionByTable: 'Distribuzione per tabella (contesto)',
    distributionByLocale: 'Distribuzione per lingua',
    translationReport: 'Distribuzione stato traduzioni',
    page: 'Pagina',
    rows: 'righe',
    actions: 'Azioni',
    create: 'Crea',
    search: 'Cerca',
    closeSearch: 'Chiudi ricerca',
    help: 'Aiuto',
    helpCenter: 'Centro assistenza',
    helpAboutPage: 'Informazioni su questa pagina',
    helpDocumentation: 'Documentazione',
    helpKeyboardShortcuts: 'Scorciatoie da tastiera',
    helpWhatsNew: 'Novità',
    helpF1Hint: 'Premi F1 per ricevere assistenza su questa pagina',
    helpNoDocsForPage: 'La documentazione di questa pagina non è ancora disponibile',
    aiAssistantTitle: 'Assistente IA QubePro',
    aiAssistantButton: 'Assistente IA',
    aiAssistantUnavailable: 'L’assistente IA non è al momento disponibile.',
    appearancePreference: 'Preferenza di visualizzazione',
    modalControlPlacement: 'Posizione dei controlli del modulo',
    modalControlPlacementHint: 'Imposta la posizione dei controlli di chiusura e schermo intero nei moduli.',
    modalControlPlacementSystem: 'Sistema (consigliato)',
    modalControlPlacementWindows: 'Windows',
    modalControlPlacementMacos: 'macOS',
    productTour: {
      start: 'Avvia il tour del prodotto',
      restart: 'Riavvia il tour del prodotto',
      navigationTitle: 'Barra laterale e moduli',
      navigationDescription: 'Usa la barra laterale per accedere ai moduli e alle pagine autorizzati ed espandere o comprimere ogni sezione.',
      appsTitle: 'Applicazioni',
      appsDescription: 'Apri le applicazioni QubePro e passa da una all’altra qui.',
      profileTitle: 'Profilo e azienda',
      profileDescription: 'Gestisci qui il profilo, l’azienda selezionata e le preferenze della lingua.',
      aiTitle: 'QubePro AI',
      aiDescription: 'Apri l’assistente IA QubePro per ricevere aiuto relativo alla pagina corrente.',
      helpTitle: 'Centro assistenza',
      helpDescription: 'Apri la documentazione o riavvia questo tour del prodotto in qualsiasi momento.',
      next: 'Avanti',
      previous: 'Indietro',
      done: 'Fine',
      close: 'Chiudi',
      neverShowAgain: 'Non mostrare più automaticamente',
      progress: '{{current}} / {{total}}',
    },
    userExtensions: 'Estensioni',
    close: 'Chiudi',
    modalFocus: 'Concentra sul modulo',
    modalFullscreen: 'Passa a schermo intero',
    modalRestore: 'Ripristina dimensioni',
    filterByColumn: 'Filtra per {column}',
    formCustomFieldsLoading: 'Caricamento dei campi personalizzati…',
    formCustomFieldsLoadError: 'Impossibile caricare i campi personalizzati. Riprova prima di salvare per evitare la perdita di dati.',
    formCustomFieldsRetry: 'Riprova',
    pageUnavailableTitle: 'Impossibile aprire la pagina',
    pageUnavailableMessage: 'Puoi aprire un’altra pagina dal menu oppure aggiornare questa pagina.',
    pageReloadWarning: 'L’aggiornamento elimina le modifiche non salvate.',
    allTargetLanguages: 'Tutte le lingue (10 lingue)',
    darkMode: 'Modalità scura',
    lightMode: 'Modalità chiara',
    errorOccurred: 'Si è verificato un errore',
    confirm: 'Conferma',
    context: 'Tabella',
    key: 'Colonna',
    originalShort: 'Orig.',
    originalValue: 'Valore originale',
    locale: 'Lingua',
    value: 'Valore',
    status: 'Stato',
    auto: 'Auto',
    manual: 'Manuale',
    manageLocales: 'Gestisci lingue',
    updateUntranslatedFields: 'Sincronizza nuovi campi',
    autoTranslate: 'Traduzione automatica',
    sourceAndTargetMustDiffer: 'La lingua sorgente e destinazione devono essere diverse.',
    autoTranslateSuccessCount: '{count} elementi tradotti automaticamente.',
    syncEntriesResult: 'Sincronizzate {count} nuove voci di traduzione.',
    translated: 'Translated',
    missing: 'Mancante',
    autoTranslateScope: 'Ambito traduzione automatica',
    updateUntranslatedFieldsHint: 'Clicca su "Aggiorna nuovi campi" per sincronizzare i contenuti da queste tabelle.',
    processing: 'Elaborazione...',
    enterTargetLanguage: 'Seleziona lingua di destinazione.',
    sourceLanguage: 'Lingua sorgente',
    selectLanguagesFirst: 'Prima seleziona le lingue in Gestisci lingue',
    sourceLanguageLabel: 'Lingua sorgente (la tua interfaccia)',
    targetLanguage: 'Lingua di destinazione',
    activeLocalesDescription: 'Seleziona le lingue attive. Salvato solo come impostazione.',
    selectSourceLanguageForSync: 'In quale lingua sono i contenuti?',
    languageNames: {
      en: 'Inglese',
      tr: 'Turco',
      de: 'Tedesco',
      fr: 'Francese',
      es: 'Spagnolo',
      ar: 'Arabo',
      it: 'Italiano',
      ja: 'Giapponese',
      zh: 'Cinese',
      ru: 'Russo',
    },
    warning: 'Avviso',
  },
  login: {
    ...coreMessages.login,
    loginFailed: 'Accesso fallito',
    emailRequired: 'Indirizzo email obbligatorio',
    passwordRequired: 'Password obbligatoria',
    backendUnavailable: 'Server non disponibile. Riprova piu tardi.',
    backendConnectFailed: 'Impossibile connettersi al server. Riprova piu tardi.',
    backendConnectFailedDev: 'Impossibile connettersi al server. Verifica che sia in esecuzione ({apiUrl}).',
    emailLabel: 'Email',
    emailPlaceholderFull: 'Inserisci la tua email',
    passwordLabel: 'Password',
    passwordPlaceholderFull: 'Inserisci la password',
    hidePassword: 'Nascondi password',
    showPassword: 'Mostra password',
    loggingIn: 'Accesso in corso...',
    submitButton: 'Accedi',
    errors: {
      ...coreMessages.login.errors,
      invalidCredentials: 'Email o password non corretti. Riprova.',
      sessionTooLarge: 'Dati di sessione troppo grandi. Riprova ad accedere.',
      databaseUnavailable: 'Il database non è disponibile o è richiesta la configurazione. Accedi di nuovo.',
      accountInactive: 'Il tuo account non è attivo. Contatta l\'amministratore di sistema.',
      sessionExpired: 'La sessione è scaduta. Accedi di nuovo.',
      tooManyAttempts: 'Troppi tentativi. Riprova più tardi.',
    },
    featureTitle: "Collega i dati operativi e finanziari",
    featureDescription: "Segui scorte, acquisti, vendite e dati finanziari con QubePro ERP.",
    featureCard1Title: "Prodotti e scorte",
    featureCard1Description: "Gestisci prodotti, magazzini e movimenti di scorte.",
    featureCard2Title: "Acquisti",
    featureCard2Description: "Segui documenti e ordini di acquisto.",
    featureCard3Title: "Documenti di vendita",
    featureCard3Description: "Gestisci ordini di vendita e fatture.",
    featureCard4Title: "Movimenti finanziari",
    featureCard4Description: "Esamina registrazioni bancarie, di cassa e finanziarie.",
    darkMode: 'Modalità scura',
    lightMode: 'Modalità chiara',
    pleaseWait: 'Attendere prego',
    serverConfiguring: 'Configurazione del server in corso...',
    dbCreating: 'Creazione del database e delle configurazioni. Operazione in corso.',
    loginPageTitle: 'Accesso',
    languageToggleLabel: 'Lingua',
  },
  sidebar: {
    ...coreMessages.sidebar,
    dashboard: 'Dashboard',
    settings: 'Impostazioni',
    toggleMenu: 'Apri menu',
    toggleMenuClose: 'Chiudi menu',
    companies: 'Aziende',
    logout: 'Esci',
    activityLogs: 'Registri attività',
  },
  customFields: {
    title: 'Campi personalizzati',
    newField: 'Nuovo campo personalizzato',
    editField: 'Modifica campo personalizzato',
    entityType: 'Tipo record',
    code: 'Codice campo',
    label: 'Nome visualizzato',
    codePlaceholder: 'es. livelloRischio',
    labelPlaceholder: 'es. Codice speciale 1',
    dataType: 'Tipo dati',
    type: 'Tipo',
    scope: 'Ambito',
    companyId: 'ID azienda',
    companySelection: 'Aziende',
    companySelectionPlaceholder: 'Vuoto è globale, oppure seleziona aziende',
    selectedCompanies: '{{count}} aziende selezionate',
    selectAllCompanies: 'Seleziona tutte le aziende',
    sortOrder: 'Ordine',
    required: 'Obbligatorio',
    searchable: 'Ricercabile',
    showInForm: 'Mostra nel modulo',
    showInList: 'Mostra colonna',
    formTab: 'Scheda modulo',
    formTabSelect: 'Scheda modulo',
    formTabPlaceholder: 'Vuoto usa la scheda Campi personalizzati',
    defaultCustomTab: 'Campi personalizzati',
    selectEntityTypeFirst: 'Seleziona prima il tipo',
    newFormTab: 'Nuova scheda',
    tabCode: 'Codice scheda',
    tabName: 'Nome scheda',
    tabCodePlaceholder: 'es. operazioni',
    tabNamePlaceholder: 'es. Dati operativi',
    fieldWidth: 'Layout riga',
    widthFull: '1 campo per riga',
    widthHalf: '2 campi per riga',
    widthThird: '3 campi per riga',
    widthQuarter: '4 campi per riga',
    systemField: 'Campo di sistema',
    description: 'Descrizione',
    options: 'Opzioni',
    optionsPlaceholder: 'Ogni riga: codice:Etichetta\nEsempio: draft:Bozza\no solo Bozza',
    defaultValue: 'Valore predefinito',
    statusDistributionTitle: 'Distribuzione stato {{title}}',
    emptyMessage: 'Nessun campo personalizzato definito.',
    globalScope: 'Globale',
    companyScope: 'Azienda {{id}}',
    deleteSelected: 'Elimina selezionati',
    deleteSelectedMessage: 'Verranno eliminati {{count}} campi personalizzati. Questa azione non può essere annullata.',
    formDesigner: 'Design modulo',
    formDesignerTitle: 'Design dei campi personalizzati',
    formDesignerEntityType: 'Tipo di record da progettare',
    formDesignerAllTabs: 'Tutti',
    formDesignerEmpty: 'Nessun campo personalizzato per questo tipo di record.',
    formDesignerOriginalNotice: 'I campi originali del modulo sono preservati; questa schermata gestisce schede, ordine e layout di riga dei campi personalizzati.',
    formDesignerSave: 'Salva design',
    formDesignerSaved: 'Design del modulo salvato.',
    formDesignerMoveUp: 'Sposta su',
    formDesignerMoveDown: 'Sposta giù',
    formDesignerFieldSettings: 'Layout campo',
    formDesignerQuickSave: 'Salva',
    formDesignerEditTab: 'Modifica scheda',
    formDesignerDeleteTab: 'Elimina scheda',
    formDesignerTabEditorTitle: 'Impostazioni scheda',
    formDesignerCloseTabEditor: 'Chiudi editor scheda',
    dataTypes: {
      text: 'Testo',
      number: 'Numero',
      date: 'Data',
      datetime: 'Data/ora',
      boolean: 'Sì/No',
      select: 'Selezione',
      json: 'JSON',
    },
  },
  activityLogs: {
    title: 'Registri attività',
    searchPlaceholder: 'Cerca (entità, modulo, azione)…',
    allModules: 'Tutti i moduli',
    allActions: 'Tutte le azioni',
    allSeverity: 'Tutte le gravità',
    allApps: 'Tutte le applicazioni',
    startDate: 'Data inizio',
    endDate: 'Data fine',
    exportCsv: 'Esporta CSV',
    total: 'Totale',
    today: 'Oggi',
    critical: 'Critico',
    warning: 'Avviso',
    severityInfo: 'Info',
    exportFilenameStem: 'registri-attivita',
    noLogs: 'Nessun registro attività trovato.',   system: 'Sistema',
    field: 'Campo',
    oldValue: 'Valore precedente',
    newValue: 'Nuovo valore',
    ip: 'IP',
    meta: 'Metadati richiesta',
    userAgent: 'User-Agent',
    entity: 'Entità',
    severityCol: 'Gravità',
    userCol: 'Utente',
    actionCol: 'Azione',
    moduleCol: 'Modulo',
    dateCol: 'Data',
    appCol: 'Applicazione',
    overviewTitle: 'Panoramica',
    severityChart: 'Distribuzione gravità',
    topModulesChart: 'Moduli principali per volume',
    csvId: 'ID',
    csvDate: 'Data',
    csvUser: 'Utente',
    csvAction: 'Azione',
    csvModule: 'Modulo',
    csvEntity: 'Entità',
    csvSeverity: 'Gravità',
    csvIp: 'IP',
    csvApplication: 'Applicazione',
    companyCol: 'ID azienda',
    allOutcomes: 'Tutti gli esiti',
    noLogsDesc: 'I registri appariranno qui quando gli utenti eseguiranno delle azioni.',
    entityType: 'Tipo di record',
    actorType: 'Tipo di attore',
    outcome: 'Esito',
    successful: 'Riuscito',
    failed: 'Non riuscito',
    denied: 'Negato',
    reason: 'Motivo',
    requestId: 'ID richiesta',
    correlationId: 'ID correlazione',
    integrity: 'Prova di integrità',
    outboxWarning: 'La coda di consegna audit richiede attenzione.',
  },

  // Header Notifications page
  headerNotifications: {
    tabNotifications: 'Notifiche',
    tabPreferences: 'Preferenze',
    markAllRead: 'Segna tutto come letto',
    notifCount: '{total} notifiche',
    unreadCount: '{count} non lette',
    loading: 'Caricamento notifiche...',
    noNotifications: 'Nessuna notifica',    markRead: 'Segna come letto',
    delete: 'Elimina',   noPreferences: 'Nessuna preferenza',
    noPreferencesDesc: 'Nessuna categoria di notifica trovata. Le preferenze vengono create automaticamente alla ricezione delle notifiche.',
    preferencesHeader: 'Preferenze notifiche in-app',
    prefItemDesc: 'Ricevi le notifiche di questa categoria nell\'app',
    readDistribution: 'Distribuzione stato di lettura',
    readStatusLabel: 'Stato di lettura',
    filterAll: 'Tutte',
    filterUnread: 'Non lette',
    filterRead: 'Lette',    colType: 'Tipo',
    colTitle: 'Titolo',
    colMessage: 'Messaggio',
    colDate: 'Data',
    colRead: 'Stato',
    statusUnread: 'Non letto',
    statusRead: 'Letto',
    searchNotifications: 'Cerca titolo o messaggio…',
  },
};
